export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'

export const SET_SHOW_TASK = 'SET_SHOW_TASK'

export const SET_SHOW_WATERAREA = 'SET_SHOW_WATERAREA'

export const SET_SHOW_ECOLOGICALLINE = 'SET_SHOW_ECOLOGICALLINE'

export const SET_SHOW_NATURERESERVE = 'SET_SHOW_NATURERESERVE'

export const SET_SHOW_PUMPSTATION = 'SET_SHOW_PUMPSTATION'

export const SET_SHOW_OUTLET = 'SET_SHOW_OUTLET'

export const SET_SHOW_ENTERPRISE = 'SET_SHOW_ENTERPRISE'

export const SET_SHOW_UAV = 'SET_SHOW_UAV'

export const SET_SHOW_VEHICLE = 'SET_SHOW_VEHICLE'

export const SET_SHOW_EQUIPMENT = 'SET_SHOW_EQUIPMENT'

export const SET_SHOW_PERSONNEL = 'SET_SHOW_PERSONNEL'

export const SET_SHOW_LEFT_MENU = 'SET_SHOW_LEFT_MENU'

export const SET_SHOW_RIGHT_MENU = 'SET_SHOW_RIGHT_MENU'

export const SET_SHOW_NAV_BAR = 'SET_SHOW_NAV_BAR'

export const SET_BEGIN_RANG = 'SET_BEGIN_RANG'

export const SET_CHANGE_MAP = 'SET_CHANGE_MAP'

export const SET_SHOW_STATISTICL = 'SET_SHOW_STATISTICL'

export const SET_CHANGE_TYPE = 'SET_CHANGE_TYPE'

export const SET_CHANGE_POINT = 'SET_CHANGE_POINT'

export const SET_MESSAGES = 'SET_MESSAGES'

export const SET_USER = 'SET_USER'

export const SET_SESSIONS = 'SET_SESSIONS'

export const SEND_MESSAGE = 'SEND_MESSAGE'

export const SELECT_SESSION = 'SELECT_SESSION'

export const SET_FILTER_KEY = 'SET_FILTER_KEY'

export const SET_MSGMAP = 'SET_MSGMAP'

export const SET_INFO_MAP = 'SET_INFO_MAP'

export const SET_PREPAGE_INFO = 'SET_PREPAGE_INFO'




// WEBPACK FOOTER //
// ./src/store/mutation-types.js